module.exports = "/_next/static/images/install-button-073ff6d7fa7253e0d5ab3141a5474385.png";